import { render, staticRenderFns } from "./answerResult.vue?vue&type=template&id=62c67874&scoped=true&"
import script from "./answerResult.vue?vue&type=script&lang=js&"
export * from "./answerResult.vue?vue&type=script&lang=js&"
import style0 from "./answerResult.vue?vue&type=style&index=0&id=62c67874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c67874",
  null
  
)

export default component.exports